// @flow

import React from 'react';
import { findDOMNode } from 'react-dom';
import { observer } from 'mobx-react';
import { observable, action, runInAction } from 'mobx';
import { gql, graphql } from 'react-apollo';

import type { Review as ReviewType } from '~/types';
import ReviewMain from '~/components/content/review/ReviewMain';

const ReviewMainWithData = graphql(
    gql`
    query Review($slug: String!){
        reviews (slug: $slug) {
            id,
            name,
            slug,
            headline,
            version,
            publishedAt,
            platform {
                name
            }
            content {
                extended {
                    md
                }
            }
            difficulty,
            visuals {
                score,
                text {
                    md
                }
            },
            soundtrack {
                score,
                text {
                    md
                }
            },
            controls {
                score,
                text {
                    md
                }
            },
            gameplay {
                score,
                text {
                    md
                }
            },
            story {
                score,
                text {
                    md
                }
            },
            innovation {
                score,
                text {
                    md
                }
            },
            length {
                score,
                text {
                    md
                }
            },
            objectiveScore {
                score,
                text {
                    md
                }
            },
            subjectiveScore {
                score,
                text {
                    md
                }
            },
            screenshots {
                secure_url
            },
            package {
                secure_url
            },
            author {
                name,
                slug,
                avatar {
                    secure_url
                }
            },
            game {
                name,
                japanese,
                content {
                    brief {
                        md
                    }
                }
                genres {
                    id,
                    name,
                    image {
                        secure_url
                    },
                    slug
                },
                releaseDates {
                    jp,
                    us,
                    eu,
                    aes,
                    mvs
                },
                image {
                    secure_url
                },
                backgroundImage {
                    secure_url
                },
                developer {
                    name
                },
                publisher {
                    name
                },
            }
        }
    }`,
    {
        options: props => ({
            variables: {
                slug: props.params.slug,
            },
        }),
        props: ({ data: { reviews: [review] = [] } }) => ({
            review: review,
        }),
    }
)(ReviewMain);

@observer
export default class ReviewMainContainer extends React.Component {
    props: {
        children: any,
        review: ReviewType,
    };

    constructor() {
        super();

        this.openScreenshotsGallery = this.openScreenshotsGallery.bind(this);
        this.closeScreenshotsGallery = this.closeScreenshotsGallery.bind(this);
        this.openPackageGallery = this.openPackageGallery.bind(this);
        this.closePackageGallery = this.closePackageGallery.bind(this);
        this.addBox = this.addBox.bind(this);
    }

    openScreenshotsGallery: Function;
    closeScreenshotsGallery: Function;
    openPackageGallery: Function;
    closePackageGallery: Function;
    addBox: Function;

    @observable isScreenshotsGalleryOpen: boolean;
    @observable isPackageGalleryOpen: boolean;
    @observable screenshotsCurrentImage: number;
    @observable packageCurrentImage: number;
    @observable boxes = [];
    @observable boxesMaxHeight: number;

    @action openScreenshotsGallery(index: number) {
        this.isScreenshotsGalleryOpen = true;
        this.screenshotsCurrentImage = index;
    }

    @action closeScreenshotsGallery() {
        this.isScreenshotsGalleryOpen = false;
    }

    @action openPackageGallery(index: number) {
        this.isPackageGalleryOpen = true;
        this.packageCurrentImage = index;
    }

    @action closePackageGallery() {
        this.isPackageGalleryOpen = false;
    }

    @action addBox(box: HTMLElement) {
        this.boxes = [...this.boxes, box];
    }

    componentDidMount() {
        const heights = this.boxes.filter(b => !!b).map(b => {
            const node = findDOMNode(b);

            if (node instanceof HTMLElement) {
                return node.clientHeight;
            }

            return 0;
        });

        runInAction(() => {
            this.boxesMaxHeight = Math.max(...heights);
        });
    }

    render() {
        return (
            <ReviewMainWithData
                isScreenshotsGalleryOpen={ this.isScreenshotsGalleryOpen }
                isPackageGalleryOpen={ this.isPackageGalleryOpen }
                screenshotsCurrentImage={ this.screenshotsCurrentImage }
                packageCurrentImage={ this.packageCurrentImage }
                boxesMaxHeight={ this.boxesMaxHeight }
                openScreenshotsGallery={ this.openScreenshotsGallery }
                closeScreenshotsGallery={ this.closeScreenshotsGallery }
                openPackageGallery={ this.openPackageGallery }
                closePackageGallery={ this.closePackageGallery }
                addBox={ this.addBox }
                { ...this.props }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/content/review/ReviewMainContainer.js